/** Shared page context for Copilot chat (read by CopilotBubble on send). */
export const COPILOT_PAGE_CONTEXT_KEY = 'copilot-page-context-v1';

export function setCopilotPageContext(payload) {
  try {
    if (!payload || typeof payload !== 'object') {
      sessionStorage.removeItem(COPILOT_PAGE_CONTEXT_KEY);
      return;
    }
    sessionStorage.setItem(COPILOT_PAGE_CONTEXT_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function getCopilotPageContext() {
  try {
    const raw = sessionStorage.getItem(COPILOT_PAGE_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCopilotPageContext() {
  try {
    sessionStorage.removeItem(COPILOT_PAGE_CONTEXT_KEY);
  } catch {
    /* ignore */
  }
}
